<app-ship-details
  *ngIf="ship"
  [shipData]="ship"
  [shipResultArray]="shipResultArray"
  (newShipSelectedEmitter)="onShipChange($event)"
>
</app-ship-details>
<div
  class="card card-nc"
  *ngIf="hasEntitlement('TAB_SHIP_ROSTER') && identities"
>
  <div class="card-heading">
    <i class="fa fa-home"></i>
    <span class="card-title"> Search Roster</span>
  </div>
  <div style="padding-top: 30px" class="card-body">
    <form class="" name="rosterSearchForm" [formGroup]="rosterSearchForm">
      <div class="form-group row">
        <div class="col-md-6 align-vertical" *ngIf="!isBranch">
          <input
            formControlName="firstParameter"
            name="firstParameter"
            id="firstParameter"
            class="form-control input-sm"
            type="text"
            placeholder="Please enter search criteria."
            #val1
          />
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !rosterSearchForm.get('firstParameter').valid &&
              rosterSearchForm.get('firstParameter').touched &&
              rosterSearchForm.get('firstParameter').errors['required']
            "
          >
            Required
          </span>
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !rosterSearchForm.get('firstParameter').valid &&
              rosterSearchForm.get('firstParameter').touched &&
              rosterSearchForm.get('firstParameter').errors['nameError']
            "
          >
            At least 2 characters required
          </span>
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !rosterSearchForm.get('firstParameter').valid &&
              rosterSearchForm.get('firstParameter').touched &&
              rosterSearchForm.get('firstParameter').errors['ssnError']
            "
          >
            Numbers only allowed
          </span>
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !rosterSearchForm.get('firstParameter').valid &&
              rosterSearchForm.get('firstParameter').touched &&
              rosterSearchForm.get('firstParameter').errors['ssnLenError']
            "
          >
            4 digits are required
          </span>
        </div>
        <div class="col-md-6 align-vertical" *ngIf="isBranch">
          <select
            formControlName="firstParameter"
            name="firstParameter"
            id="firstParameterBranch"
            class="form-control input-sm"
            #val2
          >
            <option value="" disabled selected hidden>Please select...</option>
            <option *ngFor="let branch of branches" [value]="branch">
              {{ branch }}
            </option>
          </select>
          <span
            class="help-block has-error validationMessage"
            *ngIf="
              !rosterSearchForm.get('firstParameter').valid &&
              rosterSearchForm.get('firstParameter').touched &&
              rosterSearchForm.get('firstParameter').errors['required']
            "
          >
            Required
          </span>
        </div>
        <div class="col-md-3 align-vertical">
          <select
            class="form-control input-sm"
            id="firstType"
            name="firstType"
            formControlName="firstType"
            #opt
            (change)="changeMethod($event)"
          >
            <option *ngFor="let method of methods" [value]="method">
              {{ method }}
            </option>
          </select>
        </div>
        <div class="col-md-3">
          <button
            type="submit"
            class="form-group btn btn-primary align-content-center"
            [disabled]="spinnerFlag || firstParameter === null"
            (click)="searchRosterCardholders()"
          >
            Search <i class="fa fa-search" aria-hidden="true"></i>
          </button>
          <button
            type="reset"
            class="form-group btn btn-danger align-content-center ml-3"
            *ngIf="filters"
            (click)="clearFilters()"
          >
            Clear
          </button>
          <br />
        </div>
      </div>
    </form>
  </div>
</div>
<div
  class="missing-info-msg"
  *ngIf="hasEntitlement('TAB_SHIP_ROSTER') && identities && !isMarines"
>
  Profiles which are marked <i class="fa fa-times danger">&nbsp;</i> have an
  issue with the enrollment form and will not be included in the Roster for
  issuance. The profile should be checked for missing 2887 information and
  updated.
</div>
<div
  class="card card-nc"
  *ngIf="hasEntitlement('TAB_SHIP_ROSTER') && identities"
>
  <div class="card-heading">
    <i class="fa fa-ship"></i>
    <span class="cardHeaderHeading"> Current Ship Roster </span>
    <span class="float-right save-card">
      <button
        type="submit"
        class="btn btn-nc"
        *ngIf="isShipNotShore(ship)"
        (click)="transfer()"
        [disabled]="isSaveDisabled()"
      >
        SAVE<i
          [ngClass]="{ 'save_btn_spinner fa fa-spinner fa-spin': processing }"
        ></i>
      </button>
    </span>
  </div>
  <div class="card-body">
    <div [ngSwitch]="subview">
      <div *ngSwitchCase="'spinner'">
        <i class="fa fa-spinner fa-spin fa-4x"></i>
      </div>
      <div *ngSwitchCase="'noResults'">
        <br />
        <h5 class="alert alert-info">No results found.</h5>
      </div>
      <div *ngSwitchDefault></div>
    </div>
    <table
      *ngIf="
        identities?.length && subview != 'noResults' && subview != 'spinner'
      "
      class="table table-striped table-bordered table-hover"
    >
      <thead class="tableheading">
        <tr>
          <th class="text-center">Last Name</th>
          <th class="text-center">First Name</th>
          <th class="text-center">Middle Initial</th>
          <th class="text-center">SSN</th>
          <th class="text-center">Strip Account</th>
          <th class="text-center">Branch</th>
          <th *ngIf="isShipNotShore(ship)" class="text-center"></th>
        </tr>
      </thead>
      <tbody id="pairNewShip">
        <tr
          *ngFor="
            let identity of identities
              | slice: (page - 1) * pageSize : (page - 1) * pageSize + pageSize
          "
          id="{{ identity.id }}"
        >
          <td id="lastName">
            <a
              id="userProfilePage"
              (click)="getUserProfile(identity.acct_num)"
              >{{ identity.lastName }}</a
            >
          </td>
          <td id="firstName">{{ identity.firstName }}</td>
          <td id="middleInitial">{{ identity.middleInitial }}</td>
          <td id="ssn">{{ identity.ssn }}</td>
          <td id="stripAcct">
            {{ identity.acct_num }}
            <span *ngIf="identity.emv">
              <img
                [id]="'EMV-card-' + identity.id"
                src="assets/img/EMV.svg"
                alt=""
              />
            </span>
          </td>
          <td *ngIf="hasNoMEU(identity.meu) == false" id="militaryBranchAndMeu">
            {{ identity.militaryBranch + " - MEU " + identity.meu }}
          </td>
          <td *ngIf="hasNoMEU(identity.meu)" id="militaryBranch">
            {{ identity.militaryBranch }}
          </td>
          <td *ngIf="isShipNotShore(ship)" class="transfer">
            <button
              [hidden]="transferIds.indexOf(identity.id) !== -1"
              (click)="addTransfer(identity.id)"
            >
              Transfer
            </button>
            <button
              [hidden]="transferIds.indexOf(identity.id) === -1"
              (click)="removeTransfer(identity.id)"
            >
              Undo Transfer
            </button>
            <i *ngIf="identity.isValid != 'Y'" class="fa fa-times">&nbsp;</i>
            <i *ngIf="identity.isValid == 'Y'" class="fa fa-check">&nbsp;</i>
          </td>
        </tr>
      </tbody>
    </table>
    <span *ngIf="subview === 'noResults' || subview === 'spinner'">
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="0"
        [maxSize]="20"
        [boundaryLinks]="true"
      >
      </ngb-pagination>
    </span>
    <span *ngIf="subview !== 'noResults' && subview !== 'spinner'">
      <ngb-pagination
        [(page)]="page"
        [pageSize]="pageSize"
        [collectionSize]="identities?.length"
        [maxSize]="20"
        [boundaryLinks]="true"
      >
      </ngb-pagination>
    </span>
  </div>
</div>

<!--<div><button (click)="transfer()">Submit</button> </div>-->
